const HEIGHTS = [
  0.35, 0.6, 0.9, 0.5, 0.75, 1, 0.65, 0.4, 0.8, 0.55,
  0.95, 0.45, 0.7, 0.3, 0.85, 0.6, 1, 0.5, 0.75, 0.4,
  0.9, 0.55, 0.7, 0.95, 0.35, 0.65, 0.85, 0.45, 1, 0.6,
  0.4, 0.8, 0.5, 0.7, 0.3, 0.9, 0.55, 0.75, 0.45, 0.65,
];

export default function Waveform({ compact = false, active = true }) {
  return (
    <div
      data-testid="voice-waveform"
      role="img"
      aria-label="Decorative preview of a voice waveform. Not connected to a live voice engine yet."
      className={`flex w-full items-center justify-center gap-[3px] overflow-hidden ${compact ? "h-8" : "h-16 sm:h-20"}`}
    >
      {HEIGHTS.map((h, i) => (
        <span
          key={i}
          className={`wave-bar rounded-full ${
            i % 3 === 0 ? "bg-[#111111]" : i % 3 === 1 ? "bg-neutral-400" : "bg-neutral-300"
          } ${compact ? "w-[3px]" : "w-1 sm:w-1.5"}`}
          style={{
            height: `${h * 100}%`,
            animationDelay: `${(i % 12) * 0.11}s`,
            animationDuration: `${1.3 + (i % 5) * 0.16}s`,
            animationPlayState: active ? undefined : "paused",
            opacity: active ? 1 : 0.45,
          }}
        />
      ))}
    </div>
  );
}
